export const CONSTANTS = { URL: "https://www.reinventing.co" }
